import { map } from 'lodash';
import { useLayoutEffect, useRef, useState } from 'react';

/**
 * @returns {[ import('react').MutableRefObject, { offsetWidth: number, offsetHeight: number, clientWidth: number, clientHeight: number }]} Ref and size
 */
export const useSize = () => {
  const ref = useRef(null);
  const [size, setSize] = useState({});
  const observerRef = useRef(null);
  const observedNodeRef = useRef(null);

  // No dependency array: the observed node may not exist on the first commit
  // (e.g. a parent like InstantSearch renders null until it has started), so
  // re-check after every render and attach once the node appears or changes.
  useLayoutEffect(() => {
    const node = ref.current;
    if (node === observedNodeRef.current) {
      return;
    }
    if (observerRef.current && observedNodeRef.current) {
      observerRef.current.unobserve(observedNodeRef.current);
    }
    observedNodeRef.current = node;
    if (!node) {
      return;
    }
    try {
      if (!observerRef.current) {
        observerRef.current = new ResizeObserver((entries) => {
          map(entries, (e) => {
            const { offsetWidth, offsetHeight, clientWidth, clientHeight } = e.target || {};
            setSize({ offsetWidth, offsetHeight, clientWidth, clientHeight });
          });
        });
      }
      observerRef.current.observe(node);
    } catch (error) {
      // for browser that doesn't support ResizeObserver
      setTimeout(() => {
        const { offsetWidth, offsetHeight, clientWidth, clientHeight } = ref.current || {};
        setSize({ offsetWidth, offsetHeight, clientWidth, clientHeight });
      }, 5);
    }
  });

  useLayoutEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return [ref, size];
};
